export const SITE = {
  name: "SABAKT",
  tagline: "Industrial Engineering. Fabrication. Wear Protection. Reconditioning.",
  city: "Riyadh, Saudi Arabia",
  // [VERIFY WITH SABAKT] placeholder contact numbers
  phone: "+966 55 000 0000",
  whatsapp: "966550000000",
  email: "info@sabakt.com",
  hours: "Sunday – Thursday · 08:00 – 18:00 (AST)",
};

export const waLink = (msg = "Hello SABAKT, I have an industrial requirement.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

export const IMG = {
  hero: "https://images.unsplash.com/photo-1598302936625-6075fbd98dd7?auto=format&fit=crop&w=2000&q=80",
  sparks: "https://images.unsplash.com/photo-1714504904786-b6732390b206?auto=format&fit=crop&w=1600&q=80",
  shopfloor: "https://images.unsplash.com/photo-1508465818649-14a170138405?auto=format&fit=crop&w=1600&q=80",
  excavator1: "https://images.unsplash.com/photo-1587919968590-fbc98cea6c9a?auto=format&fit=crop&w=1600&q=80",
  excavator2: "https://images.unsplash.com/photo-1505833464198-4993b36cdfab?auto=format&fit=crop&w=1600&q=80",
  bulldozer: "https://images.unsplash.com/photo-1653201587864-c6280a0bb4eb?auto=format&fit=crop&w=1600&q=80",
  tanks: "https://images.unsplash.com/photo-1513828646384-e4d8ec30d2bb?auto=format&fit=crop&w=1600&q=80",
  silos: "https://images.unsplash.com/photo-1627052428109-576e839d100a?auto=format&fit=crop&w=1600&q=80",
  saudi: "https://images.unsplash.com/photo-1720482229339-b727dae7062d?auto=format&fit=crop&w=1600&q=80",
};

export const REQUIREMENT_TYPES = [
  "Steel Fabrication",
  "Wear Parts",
  "Hardox",
  "CCO",
  "Hardfacing",
  "Equipment Reconditioning",
  "Excavator Bucket Repair",
  "Storage Tank",
  "Concrete Plant",
  "Cement Plant",
  "Mining",
  "Industrial Maintenance",
  "Welding Consumables",
  "Other",
];

export const CITIES = ["Riyadh", "Jeddah", "Dammam", "Jubail", "Yanbu", "Rabigh", "Jazan", "Other"];
